import { useState } from "react";

import ContactDetailsContent from "@/components/molecules/renewals/landing/middle-section/contact-details/contact-details-content";
import MedicalContent from "@/components/molecules/renewals/landing/middle-section/medical/medical-content";
import PolicyDetailsContent from "@/components/molecules/renewals/landing/middle-section/policy-details/policy-details-content";
import PolicyExtrasContent from "@/components/molecules/renewals/landing/middle-section/policy-extras/policy-extras-content";
import TravellersContent from "@/components/molecules/renewals/landing/middle-section/travellers/travellers-content";
import {
  MedicalAccordionType,
  PolicyDetailsAccordionType,
  RenewalContactDetailsAccordionType,
  TravellersAccordionType,
  PolicyExtrasAccordionType,
} from "@/schema/renewal-page/middle-panel.schema";

import MiddlePanelLoadedSingleItem from "./middle-section-loaded-single-item/middle-section-loaded-single-item";

type MiddlePanelLoadedType = {
  content: {
    policyDetailsAccordionData: PolicyDetailsAccordionType;
    travellersAccordionData: TravellersAccordionType;
    contactDetailsAccordionData: RenewalContactDetailsAccordionType;
    policyExtrasAccordionData: PolicyExtrasAccordionType;
    medicalAccordionData: MedicalAccordionType;
  };
};

export default function MiddlePanelLoaded({
  content,
}: Readonly<MiddlePanelLoadedType>) {
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  return (
    <div className="flex flex-col lg:gap-spacing-l md:gap-spacing-m gap-spacing-xs">
      <MiddlePanelLoadedSingleItem
        itemId="policy-details"
        title={content.policyDetailsAccordionData.policyDetailsAccordionTitle}
        isInitialLoad={isInitialLoad}
        setIsInitialLoad={setIsInitialLoad}
        content={
          <PolicyDetailsContent
            policyDetailsAccordionData={content.policyDetailsAccordionData}
          />
        }
      />
      <MiddlePanelLoadedSingleItem
        itemId="travellers"
        title={content.travellersAccordionData?.title}
        isInitialLoad={isInitialLoad}
        setIsInitialLoad={setIsInitialLoad}
        content={
          <TravellersContent
            travellersAccordionData={content?.travellersAccordionData}
          />
        }
      />
      <MiddlePanelLoadedSingleItem
        itemId="medical-conditions"
        title={content.medicalAccordionData?.title}
        isInitialLoad={isInitialLoad}
        setIsInitialLoad={setIsInitialLoad}
        content={
          <MedicalContent medicalAccordionData={content.medicalAccordionData} />
        }
      />
      <MiddlePanelLoadedSingleItem
        itemId="policy-extras"
        title={content.policyExtrasAccordionData.policyExtrasAccordionTitle}
        isInitialLoad={isInitialLoad}
        setIsInitialLoad={setIsInitialLoad}
        content={
          <PolicyExtrasContent
            policyExtrasAccordionCMSData={content.policyExtrasAccordionData}
          />
        }
      />
      <MiddlePanelLoadedSingleItem
        itemId="contact-details"
        title={content.contactDetailsAccordionData.contactDetailsAccordionTitle}
        isInitialLoad={isInitialLoad}
        setIsInitialLoad={setIsInitialLoad}
        content={
          <ContactDetailsContent
            contactDetailsAccordionData={content.contactDetailsAccordionData}
          />
        }
      />
    </div>
  );
}
